import SpinIcon from 'Assets/icons/icon-ai-spin.svg';

import styles from './GenerateLoading.less';

const GenerateLoading = () => {
  return <img style={{ width: 24 }} className={styles.spin} src={SpinIcon} alt="Loading" />;
};

export default GenerateLoading;
